const STORAGE_PREFIX = "ph-history:";
const MAX_ENTRIES = 10;

/** Build a localStorage key for a placeholder. */
function storageKey(placeholderName: string): string {
  return `${STORAGE_PREFIX}${placeholderName.trim().toLowerCase()}`;
}

/** Get recent values for a placeholder from localStorage. */
export function getPlaceholderHistory(placeholderName: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(placeholderName));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Add a value to the placeholder history. Deduplicates and caps at MAX_ENTRIES. */
export function addPlaceholderHistory(placeholderName: string, value: string): void {
  if (!value.trim()) return;
  try {
    const existing = getPlaceholderHistory(placeholderName);
    // Move to front, remove duplicates
    const updated = [value, ...existing.filter((v) => v !== value)].slice(0, MAX_ENTRIES);
    localStorage.setItem(storageKey(placeholderName), JSON.stringify(updated));
  } catch {
    // localStorage full or unavailable — silently ignore
  }
}
